import React from "react";
import { all_routes } from "./all_routes";
import ImageWithBasePath from "components/Common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "antd";

const Error404 = () => {
  const routes = all_routes;
  const { t } = useTranslation();
  const navigate = useNavigate();



  const handleGoHome = () => {
    navigate("/dashboard");
  };

  return (
    <div>
      <div className="row justify-content-center">
        <div className="col-xxl-6 col-xl-7 col-md-6">
          <div className="d-flex flex-column justify-content-between vh-100">
            <div className="text-center pt-4">
              <ImageWithBasePath 
                src="assets/img/authentication/logo-1.webp" 
                alt="img" 
                className="img-fluid" 
                width={150} 
              />
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center mb-4">
              <div className="mb-4">
                <ImageWithBasePath
                  src="assets/img/authentication/schoolation-error-404.png"
                  className="error-img img-fluid"
                  alt="404 Error"
                  width={400}
                />
              </div>
              <h3 className="h2 mb-3">{t("404page.title")}</h3>
              <p className="text-center mb-4">
                {t("404page.description")}
              </p>
              
              <div className="d-flex gap-3">
                <Button type="primary" size="large" onClick={handleGoHome}>
                  <i className="fa fa-arrow-left me-2"></i>
                  {t("404page.backButton")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;